<template>
  <div class="riclothes-file-viewer">
    <ul v-for="value in fileList" :key="value.name">
      <li class="riclothes-file-viewer--column-container" v-if="value.is_folder">
        <span class="material-icons riclothes-file-viewer--icon" :class="{dark: $root.config.isDarkTheme}">folder</span>
        <RiClothesText>{{ `${value.name}/` }}</RiClothesText>
      </li>
      <RiClothesFileViewer v-if="value.is_folder" :fileList="value.child_list"></RiClothesFileViewer>

      <li class="riclothes-file-viewer--column-container" v-if="!value.is_folder">
        <span class="material-icons riclothes-file-viewer--icon" :class="{dark: $root.config.isDarkTheme}">text_snippet</span>
        <RiClothesText>{{ value.name }}</RiClothesText>
      </li>
    </ul>
  </div>
</template>

<script>
import RiClothesText from "../components/RiClothesText";
export default {
  name: "RiClothesFileViewer",
  components: {
    RiClothesText
  },
  props: {
    fileList: Array
  }
}
</script>

<style lang="scss" scoped>
.riclothes-file-viewer {
  & > ul {
    margin: 8px 0px;
    padding-left: 16px;
    list-style-type: none;
  }
  &--column-container {
    display: flex;
    justify-items: center;
    align-content: center;
    & > p {
      display: inline-block;
      line-height: 2rem;
      margin-left: 4px;
      word-break: break-word;
      overflow-wrap: break-word;
    }
  }
  &--icon {
    --icon-color: #666666;
    font-size: 28px;
    color: var(--icon-color);
  }
}

.dark {
  --icon-color: #7c7c7c;
}
</style>